<template>
  <div v-if="isOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <!-- Backdrop -->
    <div 
      class="absolute inset-0 bg-black bg-opacity-75 transition-opacity" 
      @click="closeModal"
    ></div>
    
    <!-- Modal Content -->
    <div 
      class="relative bg-[#1c1c1c] rounded-2xl p-6 md:p-8 w-full mx-auto shadow-xl transform transition-all"
      :class="[size === 'large' ? 'max-w-4xl' : 'max-w-lg']"
    >
      <!-- Close Button -->
      <button 
        @click="closeModal" 
        class="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      
      <!-- Title -->
      <h3 class="text-white text-xl md:text-2xl font-medium mb-4">{{ title }}</h3>
      
      <!-- Content -->
      <div class="text-gray-300">
        <slot></slot>
      </div>
      
      <!-- Footer -->
      <div v-if="$slots.footer" class="mt-6 pt-4 border-t border-gray-700">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'BaseModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'large'].includes(value)
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const isOpen = ref(props.modelValue)
    
    watch(() => props.modelValue, (newValue) => {
      isOpen.value = newValue
      
      // When modal opens, prevent body scrolling
      if (newValue) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    })
    
    const closeModal = () => {
      emit('update:modelValue', false)
    }
    
    // Clean up when component is unmounted
    const cleanup = () => {
      document.body.style.overflow = ''
    }
    
    return {
      isOpen,
      closeModal,
      cleanup
    }
  },
  beforeUnmount() {
    this.cleanup()
  }
})
</script>

<style scoped>
/* Add any specific styles here */
</style>
